// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/custom-style.css
// module id = 8
// module chunks = 0